<template>
    <div class="modal fade createNewModal" :id="id" tabindex="-1" aria-hidden="true" :data-bs-backdrop="backdrop">
        <div class="modal-dialog modal-dialog-centered">
            <div class="modal-content">
                <div class="modal-header d-block">
                    <h5 class="modal-title fw-bold text-black">{{ title ?? $t('cta.$delete.title') }}</h5>
                </div>
                <div class="modal-body">
                    <p>
                        {{ message }}
                    </p>
                </div>
                <div class="modal-footer">
                    <button type="button" class="default-btn outlined transition" data-bs-dismiss="modal" :data-bs-target="id" aria-label="Close">
                        {{ $t('cta.discard') }}
                    </button>
                    <button type="button" @click="$emit('confirm')" data-bs-dismiss="modal" :data-bs-target="id" class="default-btn transition">
                        {{ $t('cta.confirm') }}
                    </button>

                </div>
                <button type="button" class="btn-close shadow-none" data-bs-dismiss="modal" :data-bs-target="id" aria-label="Close"></button>
            </div>
        </div>
    </div>
</template>
  
<script lang="ts">
import { defineComponent } from 'vue';

export default defineComponent({
    props: {
        id: {
            type: String,
            required: false,
            default: 'confirmModal' as string
        },
        dismissible: {
            type: Boolean,
            default: true
        },
        title: String,
        message: String
    },
    name: "ConfirmModal",
    computed: {
        backdrop(): String {
            return this.dismissible === false ? 'static': 'true';
        }
    }
});
</script>